import React from "react";
import "../../components/DashboardSeller/BidModal.css";

const BidModal = () => {
    return (
      <div className="bid-modal-container">
        <div className="bid-modal">
          <div className="bid-modal-left">
            <img src="/path-to-image" alt="Steel Pipes" className="bid-modal-image" />
            <div className="bid-modal-bid-section">
              <label className="bid-modal-label">Lowest Bid</label>
              <input type="text" value="$60,00,000" readOnly className="bid-modal-input" />
              <select className="bid-modal-dropdown">
                <option value="-50000">-50,000</option>
              </select>
              <div className="bid-modal-buttons">
                <button className="bid-modal-placebid">PLACE BID</button>
                <button className="bid-modal-cancelbid">CANCEL BID</button>
              </div>
            </div>
          </div>
          <div className="bid-modal-right">
            <h2 className="bid-modal-title">Fastgear 24 inch 15mm Steel Black Wire Plumbing Connection</h2>
            <p className="bid-modal-subtitle">6 x 6 - 50 pipes.</p>
            <p className="bid-modal-description">
              Lorem ipsum dolor sit amet consectetur. Amet tincidunt fringilla erat varius massa tempus velit hac dolor. Pellentesque praesent viverra at quis vitae id.
            </p>
            <div className="bid-modal-info">
              <span className="bid-modal-time">29min 59sec</span>
              <span className="bid-modal-today">Today</span>
              <span className="bid-modal-users">04 Active User</span>
              <span className="bid-modal-price">$60,00,000</span>
            </div>
            <div className="bid-modal-order">
              <span className="bid-modal-orderid">Order ID: #12341234</span>
              <div className="bid-modal-order-details">
                <span>Lorem ipsum</span> <span className="bid-modal-bold">Loerm ipsum</span>
                <span>Lorem ipsum</span> <span className="bid-modal-bold">Loerm ipsum</span>
                <span>Lorem ipsum</span> <span className="bid-modal-bold">Loerm ipsum</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
    

export default BidModal;